import DOMPurify from 'isomorphic-dompurify';

/**
 * 許可する最小限のタグと属性のみを許可してHTMLをサニタイズします。
 * - 許可タグ: a, br
 * - 許可属性: href, target, rel
 * - javascript: や data: を含む危険なURLは除去
 * - style や on* 属性は不許可
 */
export const sanitizeHtmlAllowingLinks = (input: string): string => {
  if (!input) return '';

  // 改行は <br /> に変換して保持
  const withLineBreaks = input.replace(/\n/g, '<br />');

  const sanitized = DOMPurify.sanitize(withLineBreaks, {
    ALLOWED_TAGS: ['a', 'br'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    FORBID_ATTR: ['style'],
    // URL関連の保護（既定で有効だが明示）
    ALLOW_UNKNOWN_PROTOCOLS: false,
    USE_PROFILES: { html: true },
  });

  // target/rel の最小限の安全対策を後処理で付与
  // 既に rel がある場合は尊重しつつ不足分を補完
  return sanitized.replace(/<a\b([^>]*)>/gi, (_match, attrs) => {
    let newAttrs = attrs;

    // target がない場合は _blank を付与（仕様に合わせ調整可）
    if (!/\btarget\s*=\s*"?_blank"?/i.test(newAttrs)) {
      newAttrs += ' target="_blank"';
    }

    // rel に必要語を補完
    const relNeeded = ['noopener', 'noreferrer', 'nofollow'];
    const relMatch = newAttrs.match(/\brel\s*=\s*"([^"]*)"/i);
    if (relMatch) {
      const current = relMatch[1].split(/\s+/);
      const merged = Array.from(new Set([...current, ...relNeeded]));
      newAttrs = newAttrs.replace(relMatch[0], `rel="${merged.join(' ')}"`);
    } else {
      newAttrs += ' rel="noopener noreferrer nofollow"';
    }

    return `<a${newAttrs}>`;
  });
};
